import React from "react";
import { TextInput } from "@narmi/design_system";

const SearchBar = React.memo(
  ({
    handleSearchChange,
    searchValue,
    placeholder,
  }: {
    handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    searchValue: string;
    placeholder: string;
  }) => (
    <TextInput
      startIcon="search"
      onChange={handleSearchChange}
      placeholder={placeholder}
      value={searchValue}
      showClearButton={true}
    />
  )
);

export default SearchBar;
